// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"94e61c1b","89":"c013b3c0","109":"df67d488","163":"ebd59825","330":"fc7858ee","389":"0e615aa6","551":"f08e32c6","634":"fc7858ee","640":"31bba2d2","648":"61df24ea","986":"37a209e9"}[chunkId] + ".chunk.css";
};